"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { optimizeAudioOperation } from "../_operations/optimizeAudio";

export function OptimizeAudioContent() {
  return <MediaWorkspace operation={optimizeAudioOperation} />;
}
